import { defineMessages } from "react-intl";
import {
	allergyTypeMessages,
	validator
} from "lib/build/forms/ltx/phase-i/medical-history/allergiesAndSensitivities";
import {
	FieldData,
	FieldGroupListData,
	FieldsetData
} from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	allergiesAndSensitivities: {
		id: "form.allergies_and_sensitivities",
		defaultMessage: "Allergiák és érzékenységek"
	},
	allergyType: {
		id: "form.allergies_and_sensitivities.allergy_type",
		defaultMessage: "Allergia típusa"
	},
	allergyName: {
		id: "form.allergies_and_sensitivities.allergy_name",
		defaultMessage: "Allergia neve"
	},
	comment: {
		id: "form.allergies_and_sensitivities.comment",
		defaultMessage: "Megjegyzés"
	},
	allergy: {
		id: "form.allergies_and_sensitivities.allergy",
		defaultMessage: "Allergia"
	}
});

const allergyTypeField: FieldData = {
	type: "field",
	path: ["allergyType"],
	label: messages.allergyType,
	errorMessages: genericErrorMessages,
	input: { type: "button-group", props: { labels: allergyTypeMessages } }
};

const allergyNameField: FieldData = {
	type: "field",
	path: ["allergyName"],
	label: messages.allergyName,
	errorMessages: genericErrorMessages,
	input: { type: "input", props: { type: "text" } }
};

const commentField: FieldData = {
	type: "field",
	path: ["comment"],
	label: messages.comment,
	errorMessages: genericErrorMessages,
	input: { type: "textarea", props: {} }
};

const allergy: FieldGroupListData = {
	type: "field-group-list",
	path: ["allergy"],
	label: messages.allergy,
	rows: [
		{ columns: [{ width: 12, field: allergyTypeField }] },
		{ columns: [{ width: 12, field: allergyNameField }] },
		{ columns: [{ width: 12, field: commentField }] }
	]
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: allergy }] }]
};

export const node: LeafNode = {
	id: "allergiesAndSensitivities",
	value: {
		title: messages.allergiesAndSensitivities,
		validator,
		fieldset,
		applyCurrentDate: true
	}
};
